import _ from 'lodash'
import enabled from '../helpers/enabled'

export default (form) => (
  _.max(_.map(enabled(form, 'monthlyCosts'), 'endingAge'))
)
